import moment from 'moment';
import Api from 'services/Api';
import _ from 'lodash';

require('moment-precise-range-plugin');
require('moment-duration-format');

export const types = {
    UPDATE_CALCULATOR_VALUE: 'UPDATE_CALCULATOR_VALUE',
    UPDATE_OPTIONS: 'UPDATE_OPTIONS',
    CALCULATE_DIFFERENCE: 'CALCULATE_DIFFERENCE',
    UPDATE_OPTION: 'UPDATE_OPTION',
    RESET: 'RESET',
};

// Initial State
const state = {
    firstDate: null,
    secondDate: null,
    options: {
        show: {
            years: true,
            months: true,
            weeks: false,
            days: true,
        },
        dp: 2,
        includeFirstDay: true,
        includeLastDay: true,
        includeBankHolidays: true,
        numberOfBankHolidays: 0,
        numberOfWeekendDays: 0,
        includeWeekends: true
    },
    diffBetween: null,
    diffYears: null,
};

// Getters
const getters = {
    getCalculator: state => state
};

// Actions
const actions = {
    calculateDifference({commit, dispatch}, firstDate, secondDate, options) {
        return Api.miniCalculators.dates.PeriodBetweenTwoDates(firstDate, secondDate, options)
            .then((data) => {
                commit(types.UPDATE_OPTION, {key: 'numberOfBankHolidays', value: data.number_of_bank_holidays });
                commit(types.UPDATE_OPTION, {key: 'numberOfWeekendDays', value: data.number_of_weekend_days });
                commit(types.UPDATE_CALCULATOR_VALUE, {key: 'diffBetween', value: data.diff });
                commit(types.UPDATE_CALCULATOR_VALUE, {key: 'diffYears', value: data.years });
            })
    },
    setOptions({commit}, options) {
        commit(types.UPDATE_OPTIONS, options);
    },
    setCalculatorValue({commit}, {key, value}) {
        commit(types.UPDATE_CALCULATOR_VALUE, {key, value});
    },
    reset({ commit }) {
        commit(types.RESET);
    },
};

// Mutations
const mutations = {
    [types.UPDATE_CALCULATOR_VALUE](state, {key, value}) {
        state[key] = value;
    },
    [types.UPDATE_OPTIONS](state, options) {
        state.options = options;
    },
    [types.UPDATE_OPTION](state, {key, value}) {
        state.options[key] = value;
    },
    [types.RESET](state) {
        state.firstDate = null;
        state.secondDate = null;
        state.options.show.years = true;
        state.options.show.months = true;
        state.options.show.weeks = false;
        state.options.show.days = true;
        state.options.dp = 2;
        state.options.includeFirstDay = true;
        state.options.includeLastDay = true;
        state.options.bankHolidays = true;
        state.options.weekends = true;
        state.options.numberOfBankHolidays = 0;
        state.options.numberOfWeekendDays = 0;
        state.diffBetween = null;
        state.diffYears = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/period.js